export default "__VITE_ASSET__C$j3HftB__"